import * as RasaModal from '../../components/modal'
import * as Reference from '../reference'
import * as Types from './types'

export const FETCH_SOURCES = 'FETCH_SOURCES'

export const ADD_SOURCE = 'ADD_SOURCE'
export const ADD_FILTER = 'SOURCE_ADD_FILTER_GROUP'
export const IMPORT_SOURCES = 'IMPORT_SOURCES'
export const EXPORT_SOURCES = 'EXPORT_SOURCES'
export const UPDATE_SOURCE_INLINE = 'UPDATE_SOURCE_INLINE'

export const PAGE_PREFIX = 'SOURCES'

export const SERVER_RESOURCE = '/subscriptions'
export const SOURCES_SERVER_RESOURCE = '/sources'

export const emptyAddSourceModalState: Types.AddSourceData = {
  category_type: Reference.DEFAULT_SUBSCRIPTION_CATEGORY.name,
  content_type: Reference.DEFAULT_SUBSCRIPTION_TYPE.name,
  identifier: '',
  name: '',
  source_type: Reference.DEFAULT_SOURCE_TYPE.name,
  weight: 1.0,
}

export const SOURCE_IMPORT_SERVER_RESOURCE = '/sources/import'

export const NAME: string = 'name'
export const SOURCE_IDENTIFIER: string = 'url'

// I wish to put this in parameter store
export const SOURCE_IMPORT_SAMPLE_FILE_LOCATION: string =
  'https://s3-us-west-2.amazonaws.com/public.rasa.io/imports_sample/sources_import_sample.csv'
export const SOURCE_IMPORT_HELP_TEXT: string = `The csv file must include <b>${NAME}</b>
  and <b>${SOURCE_IDENTIFIER}</b> as headers.
  Other optional headers are:<ul>
  <li><b>source_type</b>: Possible values are RSS Feed/Twitter</li>
  <li><b>subscription_type</b>: Possible values are Content/Preferred/Lead</li>
  <li><b>category_type</b>: Possible values are Content/Job/Event/Webinar</li>
  <li><b>include_filters</b>: Comma delimited filters</li>
  <li><b>include_matches</b>: How many includes count to match if include_filters are defined</li>
  <li><b>include_filtergroups</b>: Comma delimited list of <em>named</em> filter groups</li>
  <li><b>exclude_filters</b>: Comma delimited filters</li>
  <li><b>exclude_matches</b>: How many excludes count to match if exclude_filters are defined</li>
  <li><b>exclude_filtergroups</b>: Comma delimited list of <em>named</em> filter groups</li>
  <li><b>evergreen_date</b>: a specific (YYYY-MM-DD) or relative (1 week) lookback date</li>
  </ul>Here is a <a href=${SOURCE_IMPORT_SAMPLE_FILE_LOCATION}>sample file</a>`

export const emptyImportModalState: RasaModal.FileModalData = {
  file: null,
  isValid: false,
  message: '',
  name: '',
}



// WEBPACK FOOTER //
// ./src/pages/sources/constants.ts